import styled from 'styled-components';
import Headline1 from '@twicapp/ui/components/Headline1';

const ProductType = styled(Headline1)`
  margin-bottom: 24px;
`;

export default ProductType;
